import React from "react"
import { Typography } from "@material-ui/core"

interface IProps{
    title: string,
    children: React.ReactNode
}


export default function AccountTabContent({title, children} : IProps) {
    return (
        <div>
            <Typography variant="h3">{title}</Typography>
            {children}
        </div>
    )
}